<template>
	<v-container class="login-container">
		<v-layout class="login_background" flex-wrap justify-center>
			<v-flex xs12>
				<div
					style="min-width: 360px; max-width:600px; margin:0 auto; height: 100vh;"
					:style="`background-color: ${$store.state.PointColor1};`"
				>
					<div class="px-4 ">
						<v-layout align-center>
							<div class="white--text text-left">{{ reservedaysData.title }} 대기고객 입장알림</div>
							<v-spacer></v-spacer>
							<v-btn dark icon @click="logOut()"><v-icon>mdi-logout</v-icon> </v-btn>
						</v-layout>
						<v-card class="reserveAdmin-dashboard text-left mt-1 pa-4">
							<div class="font-weight-bold">
								방문등록
								<span :style="`color: ${$store.state.PointColor10}; font-size:24px`"> {{ reserveTotalCount }}</span> / 입장
								<span :style="`color: ${$store.state.PointColor1}; font-size:24px`"> {{ reserveCount }}</span>
							</div>
							<div class="mt-4 title font-weight-bold">
								현재 미입장 고객
							</div>
							<v-layout align-end>
								<span :style="`color: ${$store.state.PointColor10}; font-size:70px; line-height: 70px;`" class="reserveWaitingCountFont">
									{{ reserveWaitingCount }}
								</span>
								<span style="font-size: 20px; font-weight: bold;">명</span>
								(동반인 제외)
								<v-spacer></v-spacer>
								<v-btn dark color="PointColor1" @click="refresh()">
									새로고침
								</v-btn>
							</v-layout>
						</v-card>
						<div class="white--text reserveAdmin-header-font text-left mt-2">
							※ 대기고객 입장 알림 전 새로고침을 클릭하시어 현재 대기고객을<br />
							<span class="ml-3">
								꼭 확인하세요.
							</span>
						</div>
						<div class="pt-4">
							<v-card class="reserveAdmin-setting text-left pa-4" elevation="0">
								<div class="text-left mb-4">
									■ 입장 알림 보내기
								</div>
								<v-layout align-center>
									<span style="font-size: 12px; white-space: nowrap;">
										대기고객
									</span>
									<div class="mx-2" style="height: 27px;">
										<select-box :sel="selectWaiting"></select-box>
									</div>
									<span style="font-size: 12px; white-space: nowrap;" class="mr-2">
										명에게
									</span>
									<v-btn elevation="0" @click="sendReserve()" color="PointColor10">
										<span style="color:white;	font-weight: bold;">
											입장알림 보내기
										</span>
									</v-btn>
									<!-- 직접입력 필드 disabled -->
									<!-- <div class="ml-2">
										<txtField v-model="resreveAdmin_txtFiled.value" :txtField="resreveAdmin_txtFiled" class="bizInput" />
									</div> -->
								</v-layout>
								<div :style="`color: ${$store.state.PointColor11}; font-size:12px; letter-spacing: -1px;`" class="mt-2">
									※ 1회 최대 입장 알림 수는 30명 입니다. 동반인을 고려한 숫자이며 <br />
									<span class="ml-3">
										필요시 30명씩 계속 알림보내기가 가능합니다.
									</span>
								</div>
							</v-card>
						</div>
						<div class="pt-4">
							<v-card class="reserveAdmin-setting text-left pa-4" elevation="0">
								<div class="text-left mb-4">
									■ 예상 대기시간 설정하기
								</div>
								<v-layout align-center>
									<span style="font-size: 12px; white-space: nowrap;">
										대기고객 30명 기준
									</span>
									<div class="mx-2" style="height: 27px;">
										<select-box :sel="selectTimes"></select-box>
									</div>
									<span style="font-size: 12px; white-space: nowrap;" class="mr-2">
										분
									</span>
									<v-btn elevation="0" @click="applyWaitingTimes()" color="black">
										<span style="color:white;	font-weight: bold;">
											적용하기
										</span>
									</v-btn>
								</v-layout>
								<div :style="`color: ${$store.state.PointColor11}; font-size:12px; letter-spacing: -1px;`" class="mt-2">
									※ 대기고객 30명을 기준으로 예상 대기 시간을 적용할 수 있습니다.<br />
									<span class="ml-3"> 10분단위로 설정 가능하며30명 전후로 자동으로 가감하여 </span><br />
									<span class="ml-3">예상 대기시간이 표시 됩니다.</span>
								</div>
							</v-card>
						</div>
						<div class="pt-4 pb-12" v-if="$route.params.code === 'wquw7972ngs' || $route.params.code === 'k8t8fhhfxb9'">
							<v-card class="reserveAdmin-setting text-left pa-4" elevation="0">
								<div class="text-left mb-4">
									■ 알림톡 재발송
								</div>
								<v-layout align-center>
									<v-btn elevation="0" @click="checkReserve()" color="black">
										<span style="color:white;	font-weight: bold;">
											발송하기
										</span>
									</v-btn>
								</v-layout>
								<div :style="`color: ${$store.state.PointColor11}; font-size:12px; letter-spacing: -1px;`" class="mt-2">
									※ 대기순번이 지났으나 입장안내 알림톡을 받지 못한 고객이 발생 할 시 클릭하여 활용
								</div>
							</v-card>
						</div>
						<!-- <v-btn @click="createReserveuser" block>
							더미 생성
						</v-btn> -->
					</div>
				</div>
			</v-flex>
		</v-layout>
		<sweetAlert :dialog="sweetInfo" />
		<sweetAlert :dialog="sweetActive" @click="updateReserveday()" />
	</v-container>
</template>

<script>
import {
	// txtField,
	selectBox,
	sweetAlert,
} from '@/components/index.js'
export default {
	components: {
		// txtField,
		selectBox,
		sweetAlert,
	},
	data() {
		return {
			sweetActive: {
				open: false,
				title: '예상대기 시간 적용하기',
				content: ``,
				modalIcon: 'success',
				cancelBtnText: '취소',
				buttonType: 'twoBtn',
			},
			sweetInfo: {
				open: false,
				title: '',
				content: ``,
				modalIcon: 'success',
				cancelBtnText: '확인',
				buttonType: 'oneBtn',
			},
			reserveTotalCount: 0,
			reserveCount: 0,
			reserveWaitingCount: 0,
			selectWaiting: {
				value: 10,
				disabled: true,
				errorMessage: '',
				hideDetail: true,
				items: [5, 10, 15, 20, 25, 30],
				outlined: true,
				class: 'small_font bizInput',
			},
			selectTimes: {
				value: 30,
				disabled: true,
				errorMessage: '',
				hideDetail: true,
				items: [4, 6, 8, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120],
				outlined: true,
				class: 'small_font bizInput',
			},
			resreveAdmin_txtFiled: {
				maxNumber: true,
				max: 30,
				type: 'Number',
				value: null,
				maxlength: '200',
				outlined: true,
				autofocus: false,
				hideDetail: true,
				errorMessage: '',
				placeholder: '직접입력',
			},
			reservedaysData: {},
		}
	},
	created() {
		this.reservedays()
		// this.reserveusers()
		this.reserveusersConnection('All')
		this.reserveusersConnection('visit')
		this.reserveusersConnection('reserve')
	},
	methods: {
		checkReserve() {
			this.$store.state.loading = true
			let tplCode = 'UA_6340'
			// if (this.$route.params.code === '8zuur7hjgcx') tplCode = 'UA_6340'
			// else if (
			// 	this.$route.params.code === '1rbo2fsusgv' ||
			// 	this.$route.params.code === 'u27duzza0rd' ||
			// 	this.$route.params.code === 'a3qyoc308j' ||
			// 	this.$route.params.code === 'wn46zxf048' ||
			// 	this.$route.params.code === '8v596gdo432' ||
			// 	this.$route.params.code === '7po2l7y344' ||
			// 	this.$route.params.code === 'oavza7zrf'
			// )
			// 	tplCode = 'TV_1117'
			// else if (this.$route.params.code === 'wquw7972ngs') tplCode = 'TV_0338'
			// else if (
			// 	this.$route.params.code === 'wvoe1vyzao' ||
			// 	this.$route.params.code === '3gsaczjfjck' ||
			// 	this.$route.params.code === '09buhz2luv1' ||
			// 	this.$route.params.code === '09buhz2luv'
			// )
			// 	tplCode = 'TX_4503'
			const data = {
				tplCode: tplCode,
				code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
			}
			this.$store
				.dispatch('checkreserve', data)
				.then(res => {
					this.$store.state.loading = false
					this.sweetInfo.open = true
					this.sweetInfo.title = '입장 알림 보내기'
					this.sweetInfo.content = `대기고객 ${res.length}명에 대한 \n입장 알림을 발송했습니다.`
				})
				.catch(() => {
					this.sweetInfo.open = true
					this.sweetInfo.title = '오류 발생'
					this.sweetInfo.content = `오류가 발생하였습니다. 잠시후 다시시도해 주세요.`
					this.$store.state.loading = false
				})
		},
		applyWaitingTimes() {
			this.sweetActive.open = true
			this.sweetActive.content = `예상 대기시간을 ${this.selectTimes.value}분으로 적용합니다.`
		},
		updateReserveday() {
			const data = {
				id: this.reservedaysData.id,
				waitingTimes: { 30: this.selectTimes.value },
			}
			this.$store.dispatch('updateReserveday', data).then(() => {
				this.sweetActive.open = false
			})
		},
		reserveusers() {
			this.$store
				.dispatch('checkReserveusers', {
					code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
					reserveState: 'visit',
					sdate:
						this.$moment()
							.subtract(1, 'd')
							.format('YYYY-MM-DD') + ' 15:00:00',
					edate: this.$moment().format('YYYY-MM-DD') + ' 15:00:00',
					limit: 3000,
				})
				.then(resReserve => {
					let datas = resReserve.data.reserveusers
					let nodata = []
					let tplCode = 'UA_6340'
					// if (this.$route.params.code === '8zuur7hjgcx') tplCode = 'UA_6340'
					// else if (
					// 	this.$route.params.code === '1rbo2fsusgv' ||
					// 	this.$route.params.code === 'u27duzza0rd' ||
					// 	this.$route.params.code === 'a3qyoc308j' ||
					// 	this.$route.params.code === 'wn46zxf048' ||
					// 	this.$route.params.code === '8v596gdo432' ||
					// 	this.$route.params.code === '7po2l7y344'
					// )
					// 	tplCode = 'TV_1117'
					// else if (this.$route.params.code === 'wquw7972ngs') tplCode = 'TV_0338'
					// else if (
					// 	this.$route.params.code === 'wvoe1vyzao' ||
					// 	this.$route.params.code === '3gsaczjfjck' ||
					// 	this.$route.params.code === '09buhz2luv1' ||
					// 	this.$route.params.code === '09buhz2luv'
					// )
					// 	tplCode = 'TX_4503'

					datas.forEach((el, index) => {
						this.$store.dispatch('sendMessage_history', { phone: el.phone, tplCode: tplCode }).then(res => {
							if (res.data.sendMessages.length === 0) {
								nodata.push(el)
							}
							if (index === datas.length - 1) {
								console.log(nodata)
								// this.messages(nodata, '입장')
							}
						})
					})
				})
		},
		reservedays() {
			this.$store
				.dispatch('reservedays', { code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code })
				.then(res => {
					this.reservedaysData = res.data.reservedays[0]
					this.selectTimes.value = this.reservedaysData.waitingTimes[30]
				})
		},
		messages_1(reserveuserse, type) {
			const data = {}
			if (type === '임박') data.tplCode = 'TO_2930'
			else data.tplCode = 'TT_9865'
			this.$store.dispatch('messages', data).then(res => {
				let message = JSON.parse(JSON.stringify(res.data.messages[0]))
				for (let index = 0; index < reserveuserse.length; index++) {
					const el = reserveuserse[index]
					let messages = message.message
					let messagesButton = message.button
					messages = messages.replace(/#{사업지명}/g, this.reservedaysData.title)
					messages = messages.replace(/#{고객명}/g, el.name)
					messages = messages.replace(/#{입장대기번호}/g, el.waitingnum)
					messages = messages.replace(/#{입장대기자수}/g, el.reserveLength)
					messages = messages.replace(/#{관람신청일시}/g, this.$moment(el.updated_at).format('YYYY-MM-DD HH:mm'))
					let buttonsData
					if (JSON.parse(messagesButton).button) {
						buttonsData = JSON.parse(messagesButton).button
					} else {
						buttonsData = JSON.parse(messagesButton)
					}
					buttonsData.forEach(element => {
						element.linkMo = element.linkMo.replace(
							/#{그룹}/g,
							this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
						)
						element.linkPc = element.linkPc.replace(
							/#{그룹}/g,
							this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
						)
						element.linkMo = element.linkMo.replace(
							/#{코드}/g,
							this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
						)
						element.linkPc = element.linkPc.replace(
							/#{코드}/g,
							this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
						)
						element.linkMo = element.linkMo.replace(/#{전화번호}/g, el.phone)
						element.linkPc = element.linkPc.replace(/#{전화번호}/g, el.phone)
						element.linkMo = element.linkMo.replace(/#{방문ID}/g, el.phone)
						element.linkPc = element.linkPc.replace(/#{방문ID}/g, el.phone)
						element.linkMo = element.linkMo.replace(
							/#{분양정보pdf}/g,
							this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
						)
						element.linkPc = element.linkPc.replace(
							/#{분양정보pdf}/g,
							this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
						)
						if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
							element.linkMo = element.linkMo.replace(
								/#{청약안내pdf}/g,
								this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
							)
							element.linkPc = element.linkPc.replace(
								/#{청약안내pdf}/g,
								this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
							)
						}
						element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
						element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
						element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
						element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
					})
					messagesButton = JSON.stringify(buttonsData)
					const data = {
						// 필수값
						senderkey: message.senderkey, //define.SENDERKEY,
						tpl_code: message.tplCode,
						sender: message.smssender,
						receiver_1: el.phone,
						subject_1: message.tplCodeStr,
						message_1: messages,
						// 여기까지 필수값
						// apikey: this.$store.state.apikey,
						// userid: this.$store.state.userid,
						recvname_1: el.name,
						failover: 'Y',
						fsubject_1: message.tplCodeStr,
						fmessage_1: messages,
						button_1: messagesButton,
					}
					this.$store.dispatch('createSendMessage', data)
				}
			})
		},
		messages(reserveuserse) {
			const data = {}
			// if (this.$route.params.code === '8zuur7hjgcx') data.tplCode = 'UA_6340'
			// else if (
			// 	this.$route.params.code === '1rbo2fsusgv' ||
			// 	this.$route.params.code === 'u27duzza0rd' ||
			// 	this.$route.params.code === 'a3qyoc308j' ||
			// 	this.$route.params.code === 'wn46zxf048' ||
			// 	this.$route.params.code === '8v596gdo432' ||
			// 	this.$route.params.code === '7po2l7y344'
			// )
			// 	data.tplCode = 'TV_1117'
			// else if (this.$route.params.code === 'wquw7972ngs') data.tplCode = 'TV_0338'
			// else if (
			// 	this.$route.params.code === 'wvoe1vyzao' ||
			// 	this.$route.params.code === '3gsaczjfjck' ||
			// 	this.$route.params.code === '09buhz2luv1' ||
			// 	this.$route.params.code === '09buhz2luv'
			// )
			// 	data.tplCode = 'TX_4503'
			// else
			data.tplCode = 'UA_6340'

			this.$store.dispatch('messages', data).then(res => {
				let message = JSON.parse(JSON.stringify(res.data.messages[0]))
				for (let index = 0; index < reserveuserse.length; index++) {
					const el = reserveuserse[index]
					let messages = message.message
					let messagesButton = message.button
					messages = messages.replace(/#{사업지명}/g, this.reservedaysData.title)
					messages = messages.replace(/#{고객명}/g, el.name)
					messages = messages.replace(/#{입장대기번호}/g, el.waitingnum)
					messages = messages.replace(/#{입장대기자수}/g, el.reserveLength)
					messages = messages.replace(/#{관람신청일시}/g, this.$moment(el.updated_at).format('YYYY-MM-DD HH:mm'))
					messages = messages.replace(/#{그룹}/g, this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code)
					messages = messages.replace(/#{코드}/g, this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code)
					messages = messages.replace(/#{방문ID}/g, el.phone)
					let buttonsData
					if (JSON.parse(messagesButton).button) {
						buttonsData = JSON.parse(messagesButton).button
					} else {
						buttonsData = JSON.parse(messagesButton)
					}
					buttonsData.forEach(element => {
						element.linkMo = element.linkMo.replace(
							/#{그룹}/g,
							this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
						)
						element.linkPc = element.linkPc.replace(
							/#{그룹}/g,
							this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
						)
						element.linkMo = element.linkMo.replace(
							/#{코드}/g,
							this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
						)
						element.linkPc = element.linkPc.replace(
							/#{코드}/g,
							this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
						)
						element.linkMo = element.linkMo.replace(/#{전화번호}/g, el.phone)
						element.linkPc = element.linkPc.replace(/#{전화번호}/g, el.phone)
						element.linkMo = element.linkMo.replace(/#{방문ID}/g, el.phone)
						element.linkPc = element.linkPc.replace(/#{방문ID}/g, el.phone)
						element.linkMo = element.linkMo.replace(
							/#{분양정보pdf}/g,
							this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
						)
						element.linkPc = element.linkPc.replace(
							/#{분양정보pdf}/g,
							this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
						)
						if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
							element.linkMo = element.linkMo.replace(
								/#{청약안내pdf}/g,
								this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
							)
							element.linkPc = element.linkPc.replace(
								/#{청약안내pdf}/g,
								this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
							)
						}
						element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
						element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
						element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
						element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
					})
					messagesButton = JSON.stringify(buttonsData)
					const data = {
						// 필수값
						senderkey: message.senderkey, //define.SENDERKEY,
						tpl_code: message.tplCode,
						sender: message.smssender,
						receiver_1: el.phone,
						subject_1: message.tplCodeStr,
						message_1: messages,
						// 여기까지 필수값
						// apikey: this.$store.state.apikey,
						// userid: this.$store.state.userid,
						recvname_1: el.name,
						failover: 'Y',
						fsubject_1: message.tplCodeStr,
						fmessage_1: messages,
						button_1: messagesButton,
					}
					this.$store.dispatch('createSendMessage', data)
				}
			})
		},
		reserveusersConnection(type) {
			const data = {
				code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
				sdate:
					this.$moment()
						.subtract(1, 'd')
						.format('YYYY-MM-DD') + ' 15:00:00',
				edate: this.$moment().format('YYYY-MM-DD') + ' 15:00:00',
			}
			if (type === 'reserve') data.reserveState = 'reserve'
			else if (type === 'visit') data.reserveState = 'visit'
			this.$store.dispatch('reserveusersConnection', data).then(res => {
				if (type === 'reserve') this.reserveWaitingCount = res.data.reserveusersConnection.aggregate.count
				else if (type === 'visit') this.reserveCount = res.data.reserveusersConnection.aggregate.count
				else this.reserveTotalCount = res.data.reserveusersConnection.aggregate.count
			})
		},
		createReserveuser() {
			const data = {
				name: '이규화',
				phone: '01050596778',
				type: 'd',
				code: 'k8t8fhhfxb9',
				business: 2,
				inputBoxId: '128',
				title: '테스트 사업지',
			}
			this.$store.dispatch('createReserveuser', data)
		},
		sendReserve() {
			const data = {
				code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
				sdate:
					this.$moment()
						.subtract(1, 'd')
						.format('YYYY-MM-DD') + ' 15:00:00',
				edate: this.$moment().format('YYYY-MM-DD') + ' 15:00:00',
				reserveState: 'reserve',
			}
			this.$store.dispatch('reserveusersConnection', data).then(res => {
				if (res.data.reserveusersConnection.aggregate.count > 0) {
					this.$store.state.loading = true
					this.$store
						.dispatch('checkReserveusers', {
							code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
							reserveState: 'reserve',
							sdate:
								this.$moment()
									.subtract(1, 'd')
									.format('YYYY-MM-DD') + ' 15:00:00',
							edate: this.$moment().format('YYYY-MM-DD') + ' 15:00:00',
							limit: this.resreveAdmin_txtFiled.value ? Number(this.resreveAdmin_txtFiled.value) : this.selectWaiting.value,
						})
						.then(resReserve => {
							let datas = resReserve.data.reserveusers
							// this.messages(
							// 	datas,
							// 	'입장',
							// 	res.data.reserveusersConnection.aggregate.count - this.resreveAdmin_txtFiled.value
							// 		? Number(this.resreveAdmin_txtFiled.value)
							// 		: this.selectWaiting.value <= 0
							// 		? 0
							// 		: res.data.reserveusersConnection.aggregate.count - this.resreveAdmin_txtFiled.value
							// 		? Number(this.resreveAdmin_txtFiled.value)
							// 		: this.selectWaiting.value,
							// )
							let tplCode = 'UA_6340'
							// if (this.$route.params.code === '8zuur7hjgcx') tplCode = 'UA_6340'
							// else if (
							// 	this.$route.params.code === '1rbo2fsusgv' ||
							// 	this.$route.params.code === 'u27duzza0rd' ||
							// 	this.$route.params.code === 'a3qyoc308j' ||
							// 	this.$route.params.code === 'wn46zxf048' ||
							// 	this.$route.params.code === '8v596gdo432' ||
							// 	this.$route.params.code === '7po2l7y344'
							// )
							// 	tplCode = 'TV_1117'
							// else if (this.$route.params.code === 'wquw7972ngs') tplCode = 'TV_0338'
							// else if (
							// 	this.$route.params.code === 'wvoe1vyzao' ||
							// 	this.$route.params.code === '3gsaczjfjck' ||
							// 	this.$route.params.code === '09buhz2luv1' ||
							// 	this.$route.params.code === '09buhz2luv'
							// )
							// 	tplCode = 'TX_4503'
							datas.forEach((el, index) => {
								const data = {
									id: el.id,
									reserveState: 'visit',
									tplCode: tplCode,
									business: Number(this.reservedaysData.business.id),
								}
								this.$store.dispatch('updateReserveuser', data).then(() => {
									if (datas.length - 1 === index) {
										this.refresh()
										// this.reserveResend(
										// 	res.data.reserveusersConnection.aggregate.count - datas.length <= 0
										// 		? 0
										// 		: res.data.reserveusersConnection.aggregate.count - datas.length,
										// )
										this.$store.state.loading = false
										this.sweetInfo.open = true
										this.sweetInfo.title = '입장 알림 보내기'
										this.sweetInfo.content = `대기고객 ${datas.length}명에 대한 \n입장 알림을 발송했습니다.`
									}
								})
							})
						})
				} else {
					this.refresh()
				}
			})
		},
		//임박 메세지 전달
		reserveResend() {
			this.$store
				.dispatch('checkReserveusers', {
					code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
					reserveState: 'reserve',
					sdate:
						this.$moment()
							.subtract(1, 'd')
							.format('YYYY-MM-DD') + ' 15:00:00',
					edate: this.$moment().format('YYYY-MM-DD') + ' 15:00:00',
					limit: this.resreveAdmin_txtFiled.value ? Number(this.resreveAdmin_txtFiled.value) : this.selectWaiting.value,
				})
				.then(resReserve => {
					let datas = resReserve.data.reserveusers
					for (let index = 0; index < datas.length; index++) {
						const el = datas[index]
						const data = {
							code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
							sdate:
								this.$moment()
									.subtract(1, 'd')
									.format('YYYY-MM-DD') + ' 15:00:00',
							edate: this.$moment().format('YYYY-MM-DD') + ' 15:00:00',
							reserveState: 'reserve',
							waitingnum: Number(el.waitingnum),
						}
						this.$store.dispatch('reserveusersConnection', data).then(res => {
							el.reserveLength = res.data.reserveusersConnection.aggregate.count - 1
							if (datas.length - 1 === index) {
								this.messages_1(datas, '임박')
							}
						})
					}
				})
		},
		refresh() {
			this.reserveusersConnection('All')
			this.reserveusersConnection('visit')
			this.reserveusersConnection('reserve')
		},
		logOut() {
			sessionStorage.removeItem('here-t')
			this.$router
				.push({
					name: 'reserveLogin',
					params: { code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code },
				})
				.catch(() => {})
		},
	},
}
</script>
<style lang="scss">
.reserveAdmin-setting {
	border-radius: 10px !important;
}
.reserveAdmin-header-font {
	letter-spacing: -1px;
	font-size: 12px;
}
.reserveAdmin-dashboard {
	background-color: #3e7ccc;
}
</style>
